<div class="login_mainwrapper">
  <div class="login_subwrapper">
    <div class="logo-mainwrapper">
      <div class="logo-subwrapper">
        <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
          alt="logo" />
      </div>
    </div>
    <h2>Change Password</h2>

    <form class="login-form" (ngSubmit)="setPassword()" autocomplete="off" [formGroup]="loginForm">
      <!-- Old Password -->
      <div class="inputwrapper">
        <div class="iconwrapper"><i class="fa fa-unlock" aria-hidden="true"></i></div>
        <mat-form-field class="login-full-width">
          <input matInput [type]="hideOld ? 'password' : 'text'" placeholder="Current Password"
            formControlName="oldPassword" />
          <button mat-icon-button matSuffix (click)="hideOld = !hideOld; $event.preventDefault()"
            [attr.aria-label]="'Hide old password'" [attr.aria-pressed]="hideOld">
            <mat-icon>{{ hideOld ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <ng-container *ngIf="submitted && loginForm.controls['oldPassword'].invalid">
          <span class="error">Current Password is required.</span>
        </ng-container>
      </div>

      <!-- New Password -->
      <div class="inputwrapper">
        <div class="iconwrapper"><i class="fa fa-key" aria-hidden="true"></i></div>
        <mat-form-field class="login-full-width">
          <input matInput [type]="hideNew ? 'password' : 'text'" placeholder="New Password"
            formControlName="newPassword" />
          <button mat-icon-button matSuffix (click)="hideNew = !hideNew; $event.preventDefault()"
            [attr.aria-label]="'Hide new password'" [attr.aria-pressed]="hideNew">
            <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <ng-container *ngIf="submitted && loginForm.controls['newPassword'].invalid">
          <span class="error" *ngIf="loginForm.controls['newPassword'].errors?.['required']">
            New Password is required.
          </span>
          <!-- <span class="error" *ngIf="loginForm.controls['newPassword'].errors?.['pattern']">
            Must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and
            one special character.
          </span> -->
        </ng-container>
      </div>

      <!-- Re-enter New Password -->
      <div class="inputwrapper">
        <div class="iconwrapper"><i class="fa fa-key" aria-hidden="true"></i></div>
        <mat-form-field class="login-full-width">
          <input matInput [type]="hideConfirm ? 'password' : 'text'" placeholder="Confirm New Password"
            formControlName="confirmPassword" />
          <button mat-icon-button matSuffix (click)="hideConfirm = !hideConfirm; $event.preventDefault()"
            [attr.aria-label]="'Hide confirm password'" [attr.aria-pressed]="hideConfirm">
            <mat-icon>{{ hideConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
        </mat-form-field>
        <ng-container *ngIf="submitted && loginForm.controls['confirmPassword'].invalid">
          <span class="error" *ngIf="loginForm.controls['confirmPassword'].errors?.['required']">
            Confirm New Password is required.
          </span>
          <span class="error" *ngIf="loginForm.controls['confirmPassword'].errors?.['pattern']">
            Must contain at least 8 characters, including one uppercase letter, one lowercase letter, one number, and
            one special character.
          </span>
        </ng-container>

        <ng-container *ngIf="submitted && loginForm.errors?.['passwordMismatch']">
          <span class="error">New Password and Confirm New Password do not match.</span>
        </ng-container>

      </div>

      <button mat-raised-button class="submit" [disabled]="loader">Submit</button>
    </form>

    <mat-progress-bar *ngIf="loader" mode="indeterminate"></mat-progress-bar>
  </div>
</div>